<script setup>
import ghmLogo from '@/assets/img/logo.svg';
import instaLogo from '@/assets/img/instagram-logo.webp';
import linkedinLogo from '@/assets/img/linkedin-logo.webp';
</script>

<template>

  <footer class="ghm-footer-section">
    <div class="ghm-footer-container">

      <!-- Left side -->
      <div class="ghm-footer-col ghm-footer-brand">

        <div class="ghm-footer-wrapper">
        <img :src="ghmLogo" alt="GHM Logo" class="ghm-footer-logo"/>
        <p class="ghm-footer-tagline">{{ $t('public.footer.tagline') }}</p>
        <a href="https://www.linkedin.com/company/ghm-gesellschaft-f%C3%BCr-handwerksmessen-mbh/" target="_blank"
          class="ghm-footer-social">
          <img :src="linkedinLogo" alt="LinkedIn" />
        </a>
        <a href="https://www.instagram.com/ghm_handwerksmessen/" target="_blank" class="ghm-footer-social">
          <img :src="instaLogo" alt="Instagram" />
        </a>
        </div>
       
      </div>

      <!-- Middle column -->
      <div class="ghm-footer-col">
        <div class="ghm-footer-wrapper">
        <h4 class="ghm-footer-heading">{{ $t('public.footer.footerExhibitions') }}</h4>
        <ul class="ghm-footer-links">
          <li><a href="https://www.iba-tradefair.com/">iba</a></li>
          <li><a href="https://www.opti.de/">opti</a></li>
          <li><a href="https://www.faf-messe.de">FAF - Farbe, Ausbau &amp; Fassade</a></li>
          <li><a href="https://www.dach-holz.com/">Dach+Holz International</a></li>
          <li><a href="https://www.ifh-intherm.de/">IFH/Intherm</a></li>
          <li><a href="https://www.zukunfthandwerk.com/">Zukunft Handwerk</a></li>
          <li><a href="https://www.ihm.de/">Internationale Handwerksmesse</a></li>
          <li><a href="https://www.heim-handwerk.de/">Heim+Handwerk</a></li>
          <li><a href="https://www.food-life.de/">Food &amp; Life</a></li>
          <li><a href="https://www.ihm-handwerk-design.com/">Handwerk &amp; Design</a></li>
          <li><a href="https://www.garten-muenchen.de/">Garten München</a></li>
        </ul>
        </div>
      </div>

      <!-- Right column -->
      <div class="ghm-footer-col">
        <div class="ghm-footer-wrapper">
        <h4 class="ghm-footer-heading">{{ $t('public.footer.footerCompany') }}</h4>
        <ul class="ghm-footer-links">
          <li><a :href="$t('public.footer.aboutUsUrl')" target="_blank">{{ $t('public.footer.footerAboutUs') }}</a>
          </li>
          <li><a :href="$t('public.footer.imprintUrl')" target="_blank">{{ $t('public.footer.footerImprint') }}</a>
          </li>
          <li><a :href="$t('public.footer.privacyUrl')" target="_blank">{{ $t('public.footer.footerPrivacy') }}</a>
          </li>
        </ul>
        </div>
      </div>
    </div>

    <hr class="ghm-footer-divider" />

    <div class="ghm-footer-bottom">
      <p>{{ $t('public.footer.footerLegalText') }}</p>
    </div>
  </footer>
</template>

<style scoped>
.login-pf body {
  /* remove background image */
  background: white;
}

div.kc-logo-text {
  /* use svg instead of png for logo */
}

:root {
  /* set primary color to orange */
  --pf-global--primary-color--100: #ff8000;
  --ghm-primary-hover-color: #e37100;
  --ghm-secondary-hover-color: #1b4b8e;
  --pf-global--primary-color--dark-100: #FF8000;
  --pf-global--primary-color--200: #F07000;
  --pf-global--active-color--100: #FF8000;
  --pf-global--active-color--200: #F07000;
  --pf-global--focus-color--100: #FF8000;
  --pf-c-button--m-control--hover--after--BorderBottomColor: #FF8000 !important;
  --pf-c-button--m-control--after--BorderBottomColor: #FF8000 !important;
  --pf-c-button--m-control--hover--after--BorderBottomColor: #FF8000 !important;
  --pf-c-button--m-control--active--after--BorderBottomColor: #FF8000 !important;

}

.card-pf {
  border: 0px solid transparent;
  border-top: 0px solid transparent;
  border-radius: 10px;
  box-shadow: none;
  margin: 0rem !important;
  padding: 0rem !important;
}

.login-pf-header {
  display: none !important;
}

a .event-card {
  color: black !important;
}

.event-card a:hover {
  color: black !important;
  text-decoration: none;
}

a.btn:hover {
  color: white !important;
  text-decoration: none;
}

#kc-form-options>span>a {
  color: var(--muted);

}

#kc-form-options>span>a:hover {
  color: var(--orange);
  text-decoration: underline;
}

.pf-c-input-group input:not([type="checkbox"]):not([type="radio"]):focus-visible {}


a:visited {
  /*color: var(--pf-global--primary-color--100)*/
}

.checkbox {
  accent-color: var(--pf-global--primary-color--100)
}

#password:focus-visible {
  border-color: #F07000 !important
}

#username:focus-visible {
  border-color: #F07000 !important
}

#kc-login {
  border-radius: 5px;
}

#kc-logout {
  border-radius: 5px;
}

.pf-c-form-control:focus {
  border-bottom: 2px solid var(--pf-global--primary-color--100);
}

.pf-c-form-control:hover {
  border-bottom: 1px solid var(--pf-global--primary-color--200);
}

.pf-c-button.pf-m-control:hover {
  border-bottom: 1px solid var(--pf-global--primary-color--200);
}

.pf-c-button.pf-m-control:focus {
  border-bottom: 2px solid #FF8000 !important;
}

.kc-logo-wrapper {
  text-align: center;
  margin-bottom: 1rem;
}

.kc-logo {
  max-height: 80px;
  /* adjust as needed */
  max-width: 200px;
  /* keeps very wide logos under control */
  height: auto;
  width: auto;
}

.ghm-logo {
  max-height: 80px;
  /* adjust as needed */
  max-width: 200px;
  /* keeps very wide logos under control */
  height: auto;
  width: auto;
}

/* Center the whole form box */
.kc-form-box {
  position: relative;
  max-width: 600px;
  /* constrain width on desktop */
  margin: 0 auto;
  /* center horizontally */
  padding: 2rem 1rem;
  /* some breathing space */
  background: white;
  /* optional: card effect */
  border-radius: 8px;
  /* optional */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  /* optional */
}

/* On small screens, let it take full width */
@media (max-width: 480px) {
  .kc-form-box {
    max-width: 100%;
    padding: 1rem;
    box-shadow: none;
    /* optional: flatten look on mobile */
  }
}







/*** hero section above form ***/
:root {
  --bg: #fff;
  --fg: #0a0a0a;
  --muted: #4b5563;
  /* gray-600 */
  --orange: #FF8000;
  --blue: #2159a6;
  --green: #8ae59c;
  --ring: #11182733;
  /* subtle focus ring */
  --maxw: 1000px;
}

.sso-hero {
  position: relative;
  color: black;
  display: flex;
  /* enable flexbox */
  align-items: center;
  /* vertical centering */
  justify-content: center;
  /* horizontal centering */
  text-align: center;
  margin-bottom: 2.5rem;
}

.sso-hero .container {
  margin: 0rem 0rem;
  max-width: var(--maxw);
  text-align: center;
  position: relative;
  padding: 0rem;
  margin-bottom: .5rem
}

.subtitle {
  margin: 18px auto 32px;
  max-width: 820px;
  color: var(--muted);
  font-size: clamp(16px, 2.2vw, 18px);
  line-height: 1.6;
}

.cta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 18px;
  margin-top: 12px;
}

.btn {
  --padY: 14px;
  --padX: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--padY) var(--padX);
  border-radius: 4px;
  font-weight: 700;
  text-decoration: none;
  border: 0px solid transparent;
  /*transition: transform .06s ease, box-shadow .2s ease, filter .2s ease, background-color .2s ease;*/
  box-shadow: 0 6px 20px #00000012;
  white-space: nowrap;
}

.btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px var(--ring);
}

.btn-orange {
  background: var(--orange);
  color: #fff;
}

.btn-orange:hover {

  background-color: var(--ghm-primary-hover-color);
}

.btn-blue {
  background: var(--blue);
  color: #fff;
}

.btn-blue:hover {
  background-color: var(--ghm-secondary-hover-color);
}

/* small screens fine-tuning */
@media (max-width: 420px) {
  .btn {
    width: 100%;
  }
}


.subx {
  font-weight: bold;
  font-size: small;
}

.bigx {
  color: black;
  font-weight: bold;
  font-size: 2.7rem;
}

#kc-header {
  display: none !important;
}


.xkc-form-box {
  position: relative;
  max-width: 600px;
  margin: 3rem auto;
  padding: 2rem 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: rgba(200, 200, 200, 0.2);
}

.xkc-form-box-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
}

.xkc-form-box-heading-text {
  color: black;
  font-weight: bold;
  font-size: x-large;
}



.footer-container {
  margin-top: 3rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}


.footer-heading {
  max-width: var(--maxw);
  color: black;
  font-weight: bold;
  font-size: x-large;

}

.footer-subheading {
  max-width: var(--maxw);
  color: rgb(155, 155, 155);
}


.icon-eye {
  color: rgb(155, 155, 155);
}

.icon-eye-off {
  color: rgb(155, 155, 155);
}

.icon-eye:hover {
  color: var(--orange);
}

.kc-password-toggle svg {
  color: rgb(155, 155, 155);
  fill: currentColor;
  stroke: currentColor;
}

.kc-password-toggle:hover svg {
  color: var(--orange);
}





/* * Footer * */
.footer-logo-container {
  max-width: var(--maxw);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  padding: 2rem 1rem;
}

.footer-logo-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* push logo top, text bottom */
  align-items: center;
  height: 300px;
  /* fixed height for equal cards, adjust as needed */
  padding: 1rem;
  box-sizing: border-box;
  text-align: center;
}

/* Logo wrapper */
.footer-logo-item img {
  max-width: 100%;
  max-height: 100px;
  /* keeps logos visually balanced */
  object-fit: contain;
  /* no stretching */
  margin-bottom: 0rem;
  /* push text down */
}

/* Text styling */
.footer-logo-item-name {
  font-weight: bold;
  font-size: large;
  margin-top: 1rem;
  color: black !important;
}

.footer-logo-item-sub {
  font-size: 0.9rem;
  color: #555 !important;
}

/* Responsive breakpoints */
@media (max-width: 900px) {
  .footer-logo-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .footer-logo-container {
    grid-template-columns: 1fr;
  }
}





/** STEPS SECTION **/

/* Container wirklich responsiv machen */
.steps-section {
  /* statt fester width */
  max-width: var(--maxw);
  width: 100%;
  margin: 0 auto;
  padding: 60px 20px;
  text-align: center;
  background: #fff;
}

/* Desktop-Default: 3 Spalten (oder was reinpasst) */
.steps-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 40px;
  justify-items: center;
}

.steps-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 50px;
}

/* Cards */
.step {
  max-width: 280px;
}

/* Tablet: 2 Spalten */
@media (max-width: 900px) {
  .steps-grid {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 32px;
  }
}

/* Mobile: 1 Spalte, Cards volle Breite */
@media (max-width: 600px) {
  .steps-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .step {
    max-width: none;
    /* nicht einschränken */
    width: 100%;
  }

  .steps-title {
    font-size: 22px;
    margin-bottom: 28px;
  }
}

.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 6px;
  color: #fff;
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 16px;
}

.step-orange {
  background: var(--orange);
  /* orange-500 */
}

.step-blue {
  background: var(--blue);
  /* blue-600 */
}

.step-green {
  background: var(--green);
  color: white;
}

.step h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 10px 0;
}

.step p {
  font-size: 15px;
  color: #444;
  line-height: 1.5;
}


/*** SUPPORT SECTION **/

.support-section {
  padding: 60px 20px;
  text-align: center;
  background: #fff;
}

.support-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 18px;
}

.support-text {
  max-width: 800px;
  margin: 0 auto 50px;
  font-size: 16px;
  color: #444;
  line-height: 1.6;
}

.support-box {
  background: #f9f9f9;
  border-radius: 12px;
  padding: 40px 30px;
  margin: 0 auto;
}

.support-icon {
  font-size: 24px;
  color: #2563eb;
  /* blue */
  margin-bottom: 10px;
}

.support-box h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 8px 0 15px;
}

.support-box p {
  color: #444;
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.btn-support {
  display: inline-block;
  padding: 12px 22px;
  border-radius: 6px;
  font-weight: 600;
  text-decoration: none;
}

a.btn-support:hover {
  color: white !important;
  text-decoration: none;
}


/** GHM FOOTER **/
.ghm-footer-section {
  background: #2D2D2D;
  color: #bbb;
  padding: 50px 20px 20px;
  font-family: sans-serif;
  width: 100%;
  position: relative;
  z-index: 1000;
}

.ghm-footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  align-items: flex-start;
}

.ghm-footer-col {
  flex: 1;
  min-width: 200px;
}



.ghm-footer-wrapper {
  width: fit-content;
  max-width: 200px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.ghm-footer-logo {
  max-width: 140px;
  margin-bottom: 15px;
}

.ghm-footer-tagline {
  font-size: 14px;
  margin: 0 0 15px;
  color: #ddd !important;
}

.ghm-footer-social img {
  width: 28px;
  height: 28px;
  margin: 1rem 0rem;
}

.ghm-footer-heading {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #ddd;
}

.ghm-footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ghm-footer-links li {
  margin-bottom: 8px;
}

.ghm-footer-links a {
  color: #bbb;
  text-decoration: none;
  font-size: 14px;
}

.ghm-footer-links a:hover {
  color: #fff;
}

.ghm-footer-divider {
  border: 0;
  border-top: 1px solid #444;
  margin: 30px 0 15px;
}

.ghm-footer-bottom {
  text-align: center;
  font-size: 13px;
  color: #aaa;
}


@media screen and (max-width: 991px) {

  .ghm-footer-col {
    text-align: left;
  }
  .ghm-footer-wrapper{
    width: 100%;
    max-width: none;
    margin-left: 0;
    margin-right: 0;
    text-align: left
  }
  .ghm-footer-brand {
    max-width: 280px;
}
}



 
/*** Language switch **/
/* ######## locale dropdown */
/* --- Locale dropdown --- */

.kc-locale-dd {
  position: relative;
  margin: 0 1rem 1rem auto;
  width: max-content;
}

.kc-locale-button {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .5rem .75rem;
  border: 1px solid #d2d2d2;
  border-radius: 2px;
  background: #fff;
  cursor: pointer;
  list-style: none;
  font-size: .92rem;
  user-select: none;
}

.kc-locale-button::-webkit-details-marker {
  display: none;
}

.kc-locale-button:focus-visible {
  outline: 2px solid #000;
  outline-offset: 3px;
}

.kc-locale-flag {
  font-size: 1rem;
  line-height: 1;
}

.kc-locale-caret {
  margin-left: .25rem;
}

.kc-locale-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  min-width: 12rem;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 2px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .08);
  padding: .35rem;
  margin: 0;
  display: none;
  z-index: 30;
}

.kc-locale-dd[open] .kc-locale-menu {
  display: block;
}

.kc-locale-item {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .5rem .6rem;
  border-radius: 2px;
  text-decoration: none;
  color: #222;
  font-size: .92rem;
}

.kc-locale-item:hover {
  background: #aaaaaaaa;
  text-decoration: none;
  color: black;
}

.kc-locale-item.is-active {
  background: #ff800033;
  color: black;
  font-weight: 600;
}

.xkc-form-box .kc-locale-dd {
  margin-bottom: .75rem;
}

/* SVG OPTION ################################## */
/*
.kc-locale-dd{ position:relative; margin:0 0 1rem auto; width:max-content; }
.kc-locale-button{
  display:flex; align-items:center; gap:.5rem;
  padding:.5rem .75rem; border:1px solid #d2d2d2; border-radius:999px;
  background:#fff; cursor:pointer; list-style:none; font-size:.92rem;
}
.kc-locale-button::-webkit-details-marker{ display:none; }
.kc-locale-button:focus-visible{ outline:2px solid #000; outline-offset:3px; }

.kc-locale-menu{
  position:absolute; right:0; top:calc(100% + 6px); min-width:12rem;
  background:#fff; border:1px solid #e5e5e5; border-radius:10px;
  box-shadow:0 8px 24px rgba(0,0,0,.08);
  padding:.35rem; margin:0; display:none; z-index:30;
}
.kc-locale-dd[open] .kc-locale-menu{ display:block; }

.kc-locale-item{
  display:flex; align-items:center; gap:.5rem;
  padding:.5rem .6rem; border-radius:8px; text-decoration:none; color:#222; font-size:.92rem;
}
.kc-locale-item:hover{ background:#f5f5f7; }
.kc-locale-item.is-active{ background:#eef5ff; color:#0a58ca; font-weight:600; }

.kc-flag{ width:18px; height:18px; border-radius:2px; object-fit:cover; }
.xkc-form-box .kc-locale-dd{ margin-bottom:.75rem; }
*/
</style>
